import React, {PureComponent, ReactNode, RefObject} from "react"

import id from "@irati/utils/id"

import {DropdownMenu} from "./styled/DropdownOverlay"

interface Props {
  toggleRef: RefObject<any>
  onClickOutside?: () => void
  children: ReactNode
  width?: number
}

interface State {
  open: boolean
}

class DropdownOverlay extends PureComponent<Props> {
  static defaultProps = {
    toggleRef: {},
    onClickOutside: () => null
  }

  state: State = {
    open: false
  }

  node = React.createRef<any>()

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick, false)
  }

  handleOutsideClick = (e: MouseEvent) => {
    const defaultFalse = {contains: () => false}
    const node = this.node.current || defaultFalse
    const toggle = this.props.toggleRef.current || defaultFalse

    if (!node.contains(e.target) && !toggle.contains(e.target)) {
      this.props.onClickOutside!()
    }
  }

  render() {
    const {children, width} = this.props
    const idNamespace = id("dropdown", this.props)

    return (
      <DropdownMenu ref={this.node} id={idNamespace} width={width}>
        {children}
      </DropdownMenu>
    )
  }
}

export default DropdownOverlay
